<div class="container p-4 text-center">
  <h3>Pagina non trovata, torna alla <a [routerLink]="[ '/']">home</a></h3>
</div>